export function updateCustomGroupNameAndSetDirtyFactory(updateCustomGroupName, setDirty) {
  return (event) => {
    updateCustomGroupName(event.target.value);
    setDirty(true);
  };
}
